import { render, staticRenderFns } from "./CoverCost.vue?vue&type=template&id=74a57638&"
import script from "./CoverCost.vue?vue&type=script&lang=js&"
export * from "./CoverCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports